document.addEventListener('DOMContentLoaded', function() {
  // 防止 Shopify 主题编辑器多次注册自定义元素
  if (customElements.get('featured-reviews-popup')) return;

  class FeaturedReviewsPopup extends HTMLElement {
    constructor() {
      super();
      this.container = this.querySelector('.featured-reviews-popup__container');
      this.items = this.querySelectorAll('.featured-reviews-popup__item');
      this.closeBtn = this.querySelector('.featured-reviews-popup__close');
      
      if (!this.container || !this.closeBtn || this.items.length === 0) return;

      this.currentIndex = 0;
      this.showDuration = parseInt(this.dataset.showDuration) || 6000;
      this.hideDuration = parseInt(this.dataset.hideDuration) || 10000;
      this.initialDelay = parseInt(this.dataset.initialDelay) || 5000;
      this.closeBehavior = this.dataset.closeBehavior || 'session';
      this.sectionId = this.dataset.sectionId || 'global';
      this.closeKey = `featured-reviews-popup-closed-${this.sectionId}`;
      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.isPaused = false;
      this.isClosed = false;
      this.timer = null;
      this.pauseInterval = null;

      this.init();
    }

    init() {
      // 关闭策略：session / daily / none
      if (this.closeBehavior === 'session' && sessionStorage.getItem(this.closeKey) === 'true') {
        return;
      }
      if (this.closeBehavior === 'daily') {
        const closedAt = parseInt(localStorage.getItem(this.closeKey), 10);
        if (!Number.isNaN(closedAt) && Date.now() - closedAt < 24 * 60 * 60 * 1000) {
          return;
        }
      }

      this.closeBtn.addEventListener('click', () => this.close());
      this.container.addEventListener('mouseenter', () => { this.isPaused = true; });
      this.container.addEventListener('mouseleave', () => { this.isPaused = false; });

      setTimeout(() => {
        if (!this.isClosed) {
          this.show();
        }
      }, this.initialDelay);
    }

    show() {
      if (this.isClosed) return;

      this.classList.remove('hidden');
      this.classList.add('visible');
      
      // 更新当前展示的评论
      this.items.forEach(item => item.classList.remove('active'));
      this.items[this.currentIndex].classList.add('active');

      // 减少动画偏好时不做自动轮播
      if (this.reducedMotion) return;

      if (this.timer) clearTimeout(this.timer);
      this.timer = setTimeout(() => {
        if (!this.isPaused) {
          this.hide();
        } else {
          // 鼠标悬停时暂停切换
          const checkPause = setInterval(() => {
            if (!this.isPaused) {
              clearInterval(checkPause);
              this.hide();
            }
          }, 1000);
          this.pauseInterval = checkPause;
        }
      }, this.showDuration);
    }

    hide() {
      if (this.isClosed) return;

      this.classList.remove('visible');
      this.classList.add('hidden');

      this.currentIndex = (this.currentIndex + 1) % this.items.length;

      if (this.timer) clearTimeout(this.timer);
      if (this.pauseInterval) clearInterval(this.pauseInterval);
      setTimeout(() => {
        if (!this.isClosed) {
          this.show();
        }
      }, this.hideDuration);
    }

    close() {
      this.isClosed = true;
      this.classList.remove('visible');
      this.classList.add('hidden');
      if (this.closeBehavior === 'session') {
        sessionStorage.setItem(this.closeKey, 'true');
      }
      if (this.closeBehavior === 'daily') {
        localStorage.setItem(this.closeKey, Date.now().toString());
      }
      if (this.timer) clearTimeout(this.timer);
      if (this.pauseInterval) clearInterval(this.pauseInterval);
    }
  }

  customElements.define('featured-reviews-popup', FeaturedReviewsPopup);
});
